// 正式
module.exports = {
  title: '共创家—平台后台管理',
  // baseUrl: 'https://platform.gongchuangjia.com/', // 正式项目地址
  baseUrl: 'https://applet.gongchuangjia.com/', // 正式项目地址
  baseApi: 'https://applet.gongchuangjia.com/admin', // 正式api请求地址
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
};
